'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var SOCKET_CONNECTION_STATUS = exports.SOCKET_CONNECTION_STATUS = {
    CONNECTED: 'CONNECTED',
    DISCONNECTED: 'DISCONNECTED'
};

var SOCKET_CONNECT = exports.SOCKET_CONNECT = 'SOCKET_CONNECT';
var SOCKET_DISCONNECT = exports.SOCKET_DISCONNECT = 'SOCKET_DISCONNECT';

var CHANNELS_UPDATED = exports.CHANNELS_UPDATED = 'CHANNELS_UPDATED';

var SOCKET_DISCONNECT_FETCH_TIMEOUT = exports.SOCKET_DISCONNECT_FETCH_TIMEOUT = 1000 * 30; // 30 seconds

var LIVE_ACTIVITY_SUFFIX = exports.LIVE_ACTIVITY_SUFFIX = '-LIVE';


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/socket/socketConstants.js
// module id = 109
// module chunks = 0